export default "__VITE_ASSET__CzH9VuqM__"